'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.submitCompleteAccount = exports.getUiCompleteAccount = exports.COMPLETE_ACCOUNT_SUCCESS = exports.COMPLETE_ACCOUNT_REQUEST = exports.COMPLETE_ACCOUNT_FAIL = undefined;

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

exports.default = reducer;

var _user = require('./user');

var _api = require('../api');

var _reselect = require('reselect');

var _modal = require('./modal');

var _analytics = require('../modules/analytics');

var _config = require('../modules/config');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* Action Types */
var COMPLETE_ACCOUNT_FAIL = exports.COMPLETE_ACCOUNT_FAIL = 'la/ui/completeAccount/FAIL';
var COMPLETE_ACCOUNT_REQUEST = exports.COMPLETE_ACCOUNT_REQUEST = 'la/ui/completeAccount/REQUEST';
var COMPLETE_ACCOUNT_SUCCESS = exports.COMPLETE_ACCOUNT_SUCCESS = 'la/ui/completeAccount/SUCCESS';

// reducer
var DEFAULT_STATE = {
    error: false,
    submitted: false,
    success: false
};

function reducer() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DEFAULT_STATE;
    var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    switch (action.type) {
        case _modal.DISMISS_COMPLETE_ACCOUNT_MODAL:
            return (0, _extends3.default)({}, state, {
                error: false,
                submitted: false,
                success: false
            });
        case COMPLETE_ACCOUNT_FAIL:
            return (0, _extends3.default)({}, state, {
                error: true,
                submitted: false,
                success: false
            });
        case COMPLETE_ACCOUNT_REQUEST:
            return (0, _extends3.default)({}, state, {
                submitted: true,
                success: false
            });
        case COMPLETE_ACCOUNT_SUCCESS:
            return (0, _extends3.default)({}, state, {
                submitted: false,
                success: true
            });
        default:
            return state;
    }
}

/* SELECTORS */
var stateSelector = function stateSelector(state) {
    return state.ui.completeAccount;
};

var getUiCompleteAccount = exports.getUiCompleteAccount = (0, _reselect.createSelector)(stateSelector, function (state) {
    return state;
});

/* ACTION CREATORS */
var submitCompleteAccount = exports.submitCompleteAccount = function submitCompleteAccount(userDetails) {
    return function () {
        var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(dispatch, getState) {
            var state, authToken, deployment, userData, response;
            return _regenerator2.default.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            _context.prev = 0;
                            state = getState();
                            authToken = (0, _user.getAuthToken)(state);
                            deployment = (0, _config.getDeployment)(state);
                            userData = (0, _user.getUserData)(state);

                            userDetails.email = (0, _user.getBidderEmail)(state);
                            userDetails.username = userData.username;
                            dispatch({
                                type: COMPLETE_ACCOUNT_REQUEST
                            });
                            _context.next = 10;
                            return _api.Bidder.postCompleteAccount({
                                authToken: authToken,
                                bidderDetails: userDetails,
                                deployment: deployment
                            });

                        case 10:
                            response = _context.sent;

                            dispatch({
                                meta: (0, _extends3.default)({}, (0, _analytics.getCompleteAccountAnalytics)(), { actionTime: Date.now() }),
                                payload: response,
                                type: COMPLETE_ACCOUNT_SUCCESS
                            });
                            _context.next = 17;
                            break;

                        case 14:
                            _context.prev = 14;
                            _context.t0 = _context['catch'](0);

                            dispatch({
                                error: true,
                                payload: _context.t0,
                                type: COMPLETE_ACCOUNT_FAIL
                            });

                        case 17:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, undefined, [[0, 14]]);
        }));

        return function (_x3, _x4) {
            return _ref.apply(this, arguments);
        };
    }();
};


//////////////////
// WEBPACK FOOTER
// ./src/redux/modules/completeAccount.js
// module id = Qs/t
// module chunks = 46